<template>
  <el-dialog :title="title" :visible.sync="modal" :before-close="handleClose" :top="top==0?'15vh':top+'px'" :close-on-click-modal="false" class="my-dialog-info" :width="width<=100?width+'%':width+'px'" :modal-append-to-body="modalAppendToBody" :append-to-body="appendToBody">
    <slot></slot>
    <!--利用插槽可以自定义内容 -->
    <span slot="footer" class="dialog-footer">
      <el-button :type="item.type?item.type:'primary'" :icon="item.icon?item.icon:''" size="small" v-for="(item, index) in btns" :key="index" @click="btnClick(item)" v-show="item.isShow || item.isShow==null">{{ item.text }}</el-button>
      <el-button size="small" @click="handleClose">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "Modal",
  props: {
    //通过调用组件传过来的值，可以直接用
    modal: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "提示",
    },
    btns: {// 底部按钮{text:'',type:'',icon:'',click:func(){}}  type:primary,success,info,warning,danger    icon:找el 图标
      type: Array,
      default: function () {
        return [];
      },
    }, width: {//最大宽度，单位：px
      type: [Number],
      default: 50,
    },top:{//margin-top  单位：px
      type:Number,
      default:0
    },appendToBody:{
      type:Boolean,
      default:true
    },modalAppendToBody:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      showmodal: this.modal,
    };
  }, mounted() {

  },
  methods: {
    handleClose(done) {
      //this.modal = !this.modal; // this.dialogVisible=!this.dialogVisible;
      //this.$emit("onClose", this.data); //执行父组件的方法，并传值
      this.$emit("update:modal", false); //执行父组件的方法，并传值
    },
    btnClick(item) {
      if (typeof item.click == "function") {
        item.click();
      }
    },
  },
};
</script>
<style scoped>
.my-dialog-info >>> .el-dialog{
  border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    margin: 0 auto;
}

.my-dialog-info >>> .el-dialog__body {
  overflow: auto;
  flex: 1;
   max-height: 60vh;
}

.my-dialog-info >>> .el-dialog__footer {
  padding: 5px !important;
  border-top: 1px solid #e8eaec;
}

.my-dialog-info >>> .el-dialog__header {
  background-image: linear-gradient(135deg, #0cd7bd 10%, #57c5f7);
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  padding: 12px 15px;
}

.my-dialog-info >>> .el-dialog__title {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/Modal.vue